import React from 'react';
import StarsFunnelThreshold from "./StarsFunnelThreshold";
import ThumbsFunnelThreshold from "./ThumbsFunnelThreshold";
import NPSFunnelThreshold from "./NPSFunnelThreshold";

export { StarsFunnelThreshold, ThumbsFunnelThreshold, NPSFunnelThreshold };
